import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const state = {
  clientsList: [],
  keywordSearchClient: '',
  selectedClient: null,
  isError: null,
  errorMessage: 'Please try again!',
  clientId: null,
  clientName: '',
  isValidToken: false,
  loginEmail: '',
  isResetPasswordSuccess: false,
  isSubmitted: false,
  allowLogin: true,
  showCaptcha: false,
  siteKey: '',
  listAM: [],
  googleAPIKey: '',
  resetPassToken: '',
  submissionMessage: '',
  changeOrderMessage: '',
  isCheckedNotification: true,
  addOns: '',
  userList: [],
  managerView: '',
  recentClientsList: [],
  isLoading: false,
  validators: [],
  isLoadingStaffing: false,
  totalClients: 0
};

export default state



// WEBPACK FOOTER //
// ./src/store/modules/clients/states.js